import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';


export class SdeliveryNoteLine extends BaseEntity {
  
  sdeliveryNoteLineNumber    : number;
  product                    : Product;

  orderedQuantity           : number = 0;
  quantity                  : number = 0;
  returnedQuantity          : number = 0;
  returnedDamagedQuantity1  : number = 0;
  returnedDamagedQuantity2  : number = 0;
  freeGoodLine              : boolean;

  unitPrice                : number = 0;
  movedQuantity1             : number;
  movedQuantity2             : number;
  movedQuantity3             : number;
  movedQuantity4             : number;


  constructor() {
    super()
  }
 
}
 


